const initialState = {
    viewConfigurations: [],
    viewSettings: {
        viewDataDictionary: [],
        queryJson: [],
        fieldOptions: {
            fieldQuery: null,
            rawQuery: null,
            fieldsData: [],
        },
        formSourceFields: [],
        sources: [],
        formPropsUpdated: false,
    },
};

export default initialState;